<div class="container mx-auto px-4 py-6">
  <div class="sticky z-40 bg-white pb-3" style="top: 64px;">
    <!-- Header Section -->
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800 mb-2">
        Registration & Renewal Income Report
      </h1>
      <p class="text-gray-600">
        Monthly and Annual Income Report for Registered Client Fees
      </p>
    </div>

    <!-- Filters and Actions -->
    <search class="lg:w-full mt-4" tuiSearch style="padding-left: 0;margin-bottom: 20px;">
        <fieldset class="flex flex-wrap items-center gap-4 border-none">
          <!-- Report Type -->
          <div class="w-[180px]">
            <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="reportTypeControl"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option *ngFor="let type of reportTypes" [value]="type">
                {{ type }}
              </option>
            </select>
          </div>

          <!-- Monthly Filter (Shown when Monthly is selected) -->
          <div class="flex gap-4" *ngIf="reportTypeControl.value === 'Monthly'">
            <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="monthControl"
              class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option *ngFor="let month of months" [value]="month.value">
                {{ month.label }}
              </option>
            </select>

            <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="yearControl"
              class="w-[100px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option *ngFor="let year of years" [value]="year">
                {{ year }}
              </option>
            </select>
          </div>

          <!-- Annually Filter (Shown when Annually is selected) -->
          <div *ngIf="reportTypeControl.value === 'Annually'">
            <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="yearControl"
              class="w-[100px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
              <option *ngFor="let year of years" [value]="year">
                {{ year }}
              </option>
            </select>
          </div>

          <button (click)="applyFilters()" appearance="secondary" size="m" tuiButton type="button"
            class="w-full sm:w-auto" style="border: 2px solid #e5e7ea; font-weight: 800">
            Search
          </button>

          <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="defaultLoader()">
            Clear
          </button>
          <button tuiButton appearance="primary" size="m" (click)="exportToExcel()" [disabled]="reportData.length === 0">
            <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 inline mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg> -->
            Export to Excel
          </button>
        </fieldset>
    </search>
  </div>

  <!-- Export Buttons -->
  <!-- <div class="bg-white rounded-lg shadow-md p-4 mb-6 mt-4">
    <div class="flex justify-end gap-3">
      <button
        tuiButton
        appearance="primary"
        size="m"
        (click)="exportToExcel()"
        [disabled]="reportData.length === 0"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 inline mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        Export to Excel
      </button>
    </div>
  </div> -->

  <!-- Loading State -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <tui-loader size="xl" [overlay]="true"></tui-loader>
  </div>

  <!-- Report Table -->
  <div *ngIf="!loading" id="printable-report" class="bg-white rounded-lg shadow-md overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th rowspan="2"
              class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Number
            </th>
            <th rowspan="2"
              class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Date
            </th>
            <th rowspan="2"
              class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Valid until
            </th>
            <th rowspan="2"
              class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Registration No. / Renewal No.
            </th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              New Registered Client's Details
            </th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Renewed Client's Details
            </th>
            <th colspan="2" class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Monthly
            </th>
          </tr>
          <tr>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Client Name, Address, Contact No.
            </th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Client Name, Address, Contact No.
            </th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
              Annual Fee
            </th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Life Time Fee
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of reportData" class="hover:bg-gray-50 transition-colors"
            [class.bg-amber-50]="item.clientArchived">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-900 border-r">
              {{ item.number }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-900 border-r">
              {{ item.date | date : "MM.dd.yyyy" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-900 border-r">
              <span *ngIf="item.periodEnd">{{ item.periodEnd | date : "MM.dd.yyyy" }}</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600 border-r">
              {{ item.registrationNo || item.renewalNo }}
              <app-client-archived-badge [visible]="!!item.clientArchived"></app-client-archived-badge>
            </td>
            <td class="px-6 py-4 text-sm text-gray-900 border-r">
              <div *ngIf="item.newClientName">
                <div>{{ item.newClientName }}</div>
                <div class="text-xs text-gray-600">{{ item.newClientAddress }}</div>
                <div class="text-xs text-gray-600">{{ item.newClientContact }}</div>
              </div>
            </td>
            <td class="px-6 py-4 text-sm text-gray-900 border-r">
              <div *ngIf="item.renewalClientName">
                <div>{{ item.renewalClientName }}</div>
                <div class="text-xs text-gray-600">{{ item.renewalClientAddress }}</div>
                <div class="text-xs text-gray-600">{{ item.renewalClientContact }}</div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 border-r">
              <span *ngIf="item.annualFee !== undefined">LKR {{ item.annualFee | number : "1.2-2" }}</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
              <span *ngIf="item.lifeTimeFee !== undefined">LKR {{ item.lifeTimeFee | number : "1.2-2" }}</span>
            </td>
          </tr>

          <!-- Total Row (previously labeled Grand Total) -->
          <tr class="bg-blue-50 font-bold" *ngIf="reportData.length > 0">
            <td colspan="6" class="px-6 py-4 text-right text-sm text-gray-900">
              TOTAL:
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-userRef-700 border-r">
              LKR {{ totalAnnualFee | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-blue-900">
              LKR {{ totalLifeTimeFee | number : "1.2-2" }}
            </td>
          </tr>

          <!-- Grand Total Row (combines Annual + Lifetime) -->
          <tr class=" font-bold" *ngIf="reportData.length > 0">
            <td colspan="6" class="px-6 py-4 text-right text-sm text-gray-900">
              GRAND TOTAL:
            </td>
            <td colspan="2" class="px-6 py-4 whitespace-nowrap text-sm text-right ">
              LKR {{ (totalAnnualFee + totalLifeTimeFee) | number : "1.2-2" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="reportData.length === 0" class="text-center py-12 text-gray-500">
      <p class="text-lg">No data found</p>
      <p class="text-sm mt-2">Click "Generate Report" to load data</p>
    </div>
  </div>

  <!-- Summary Cards -->
  <div *ngIf="!loading && reportData.length > 0" class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-sm font-medium text-gray-500 mb-2">Total Annual Fee</h3>
      <p class="text-2xl font-bold text-blue-600">
        LKR {{ totalAnnualFee | number : "1.2-2" }}
      </p>
    </div>
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-sm font-medium text-gray-500 mb-2">Total Life Time Fee</h3>
      <p class="text-2xl font-bold text-orange-600">
        LKR {{ totalLifeTimeFee | number : "1.2-2" }}
      </p>
    </div>
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-sm font-medium text-gray-500 mb-2">Total</h3>
      <p class="text-2xl font-bold text-green-600">
        LKR {{ grandTotal | number : "1.2-2" }}
      </p>
    </div>
  </div>
</div>